import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Search from "./applications/Search";
import { Settings } from "./context/SettingsContext/SettingsContext";
import settings from "./context/SettingsContext/settings";
import HomeSearch from "./applications/HomeSearch";

// ReactDOM.render(
//   <React.StrictMode>
//     <SearchForm />
//   </React.StrictMode>,
//   document.getElementById("search-form")
// );

if (document.getElementById("search")) {
  const mount = document.getElementById("search");
  const settings64 = mount ? mount.getAttribute("data-settings") : "";

  let parsedExternalSettings: Settings | null = null;
  if (mount && settings64) {
    parsedExternalSettings = JSON.parse(atob(settings64)) as Settings;
  }

  const applicationSettings = {
    ...settings,
    brands:
      parsedExternalSettings && "brands" in parsedExternalSettings
        ? parsedExternalSettings["brands"]
        : settings.brands,
  };

  ReactDOM.render(
    <React.StrictMode>
      <Search settings={applicationSettings} />
    </React.StrictMode>,
    document.getElementById("search")
  );
}

if (document.getElementById("home-search")) {
  const mount = document.getElementById("home-search");
  const settings64 = mount ? mount.getAttribute("data-settings") : "";

  let parsedExternalSettings: Settings | null = null;
  if (mount && settings64) {
    parsedExternalSettings = JSON.parse(atob(settings64)) as Settings;
  }

  const applicationSettings = {
    ...settings,
    brands:
      parsedExternalSettings && "brands" in parsedExternalSettings
        ? parsedExternalSettings["brands"]
        : settings.brands,
  };
  ReactDOM.render(
    <React.StrictMode>
      <HomeSearch settings={applicationSettings} />
    </React.StrictMode>,
    document.getElementById("home-search")
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
